import api from '@/util/app-api'

export const state = {
  items: [],
  fetched: false
}

export const mutations = {
  set(state, items) {
    state.items = [].concat(items)
    state.fetched = true
  },
}

export const actions = {
  async fetch({ state, commit }, options) {
    options = Object.assign({ force: false }, options)

    if (state.fetched && !options.force)
      return state.items

    return api.get('admin/BusinessAuthorizationItem/List/', null)
      .then(data => {
        commit('set', data)
        return data
      })
  }
}

export const getters = {
  all: state => {
    return state.items
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
